<template>
  <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
             :visible.sync="historyDialog" :before-close="handleHistoryClose" top="25vh">
    <div class="history-dialog-content">
      <div class="history-head">
        <div class="head-title">
          产品【{{ detailInfo.name }}】供应商历史报价
        </div>
        <div class="header-desc">
          温馨提示：
          因供应商的工艺各异和原料成本的波动，历史报价仅供参考，若要获得有效实时价格，请立即询价。
        </div>
      </div>
      <div v-if="quoteList.length > 0">
        <el-table :data="quoteList" border :header-cell-style="{ backgroundColor: '#F6F6F8' }">
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="value" label="数量">
            <template slot-scope="scope">
              <span>{{ scope.row.number }} {{ scope.row.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="purity" label="纯度">
            <template slot-scope="scope">
              <span>{{ scope.row.purity }}%</span>
            </template>
          </el-table-column>
          <el-table-column prop="total_price" label="价格" v-if="userInfo.vip_status==1&&userInfo.member_type==2"/>
          <el-table-column prop="custorm_price" label="价格" v-else/>
          <el-table-column prop="is_quote" label="现货">
            <template slot-scope="scope">
              <span>{{ scope.row.is_quote == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stock_day" label="备货天数"/>
          <el-table-column prop="invoice_type" label="开票类型">
            <template slot-scope="scope">
                <span>{{
                    scope.row.invoice_type == 1 ? "专票(13%)" : "普票"
                  }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                         :current-page="currentPage" @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
      <el-empty v-else description="暂无报价"/>
    </div>
  </el-dialog>

</template>
<script>
import {quote_history, purchaseAdd} from "@/api/modules/user";
export default {
  name: "history",
  props: {
    historyDialog: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      detailInfo: {},
      quoteList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  watch: {
    historyDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          quote_history(this.detailInfo.cas_no, {page: this.currentPage, limit: this.pageSize}).then((res) => {
            this.quoteList = res.data.data.data;
            this.total = res.data.data.total;
          });
        }
      }
    },
  },
  methods: {
    handleHistoryClose() {
      this.$emit('upDateState', false);
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.handleHistory();
    },
  },
}
</script>
<style scoped lang="scss">
.history-dialog-content {
  padding: 0 50px 40px;

  .history-head {
    margin-bottom: 20px;

    .head-title {
      font-weight: 600;
      font-size: 20px;
      color: #00112b;
      margin-bottom: 14px;
    }

    .header-desc {
      font-weight: 400;
      font-size: 14px;
      color: #00112b;
    }
  }

  .pagination-box {
    padding-top: 20px;
    text-align: right;
  }
}
</style>
